/* eslint-disable no-tabs */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { setTriOptionModal } from '../../ducks/sportCoachDashboardActions';
import TriOptionModal from './TriOptionModal';

const TriOptionModalOverlay = styled('div')`
  height: 100vh;
  width: 100vw;
  position: absolute;
  background-color: rgba(216, 216, 216, 0.8);
  z-index: 1002;
  pointer-events: ${(props) => (props.isActive ? 'auto' : 'none')};
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.isActive ? 0.5 : 0)};
`;

const TriOptionModalContainer = () => {
  const dispatch = useDispatch();
  const triOptionModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.triOptionModalShowing,
  );

  return (
    <>
      <TriOptionModal />
      <TriOptionModalOverlay
        isActive={triOptionModalShowing}
        onClick={
          () => dispatch(setTriOptionModal(false))
          }
      />
    </>
  );
};

TriOptionModalContainer.propTypes = { };

export default TriOptionModalContainer;
